import React, { useState } from 'react'

import { LinkIcon } from '@/icons'

import s from './FaviconFetcher.module.css'

interface FaviconFetcherProps {
  url: string
  size?: number
  animate?: boolean
}

export const FaviconFetcher = ({
  url,
  size = 32,
  animate = false,
}: FaviconFetcherProps) => {
  const [faviconUrl, setFaviconUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  React.useEffect(() => {
    setFaviconUrl('')

    if (!url) return

    const hostname = new URL(url).hostname
    const generatedFaviconUrl = `https://www.google.com/s2/favicons?sz=${
      size * 2
    }&domain=${hostname}`

    setFaviconUrl(generatedFaviconUrl)
  }, [url, size])

  return faviconUrl ? (
    <span>
      {loading && animate && LinkIcon}
      <img
        className={`${s.icon} ${loading ? s.loading : ''} ${
          animate ? s.transition : ''
        }`}
        src={faviconUrl}
        alt="Logo"
        width={size}
        height={size}
        onLoad={() => setLoading(false)}
      />
    </span>
  ) : (
    LinkIcon
  )
}
